import { cloneElement, isValidElement, type ReactElement, type ReactNode } from 'react'

export function cx(...parts: Array<string | false | null | undefined>): string {
    return parts.filter(Boolean).join(' ')
}

export function hasButtonContent(children: ReactNode): boolean {
    if (children == null || children === false || children === true) return false
    if (typeof children === 'string' && children.trim() === '') return false
    return true
}

export function renderButtonIcon(icon: ReactNode): ReactNode {
    if (!isValidElement(icon)) return icon

    const element = icon as ReactElement<{ color?: string; size?: number | string }>

    return cloneElement(element, {
        size: element.props.size ?? 16,
        color: element.props.color ?? 'currentColor',
    })
}
